import { BrowserRouter } from "react-router-dom";

import "./App.css";
import AppRouter from "./router/AppRoutes";
import "bootstrap/scss/bootstrap.scss";
import "./custom.scss";
import { getAppSettings } from "./api/api";
import { useEffect, Suspense } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import defaultFavicon from "./assets/image/Dreamland_logo.webp";

function App() {
  const setFavicon = (iconUrl) => {
    const finalIconUrl = iconUrl || defaultFavicon;
    
    // Remove existing favicon
    const existingLink = document.querySelector("link[rel='icon']");
    if (existingLink) {
      existingLink.parentNode.removeChild(existingLink);
    }

    // Create and add the new favicon
    const link = document.createElement("link");
    link.rel = "icon";
    link.href = finalIconUrl;
    link.type = "image/x-icon";
    document.head.appendChild(link);
  };

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      easing: "ease-in-out",
    });

    const fetchFavicon = async () => {
      try {
        const response = await getAppSettings();
        setFavicon(response.data?.info?.favicon);
      } catch (error) {
        console.error("Failed to load favicon:", error);
      }
    };

    fetchFavicon();

    const handleWheel = (e) => {
      if (document.activeElement.type === "number") {
        document.activeElement.blur();
      }
    };

    const preventInstallPrompt = (e) => {
      e.preventDefault();
    };

    window.addEventListener("wheel", handleWheel, { passive: false });
    window.addEventListener("beforeinstallprompt", preventInstallPrompt);

    return () => {
      window.removeEventListener("wheel", handleWheel);
      window.removeEventListener("beforeinstallprompt", preventInstallPrompt);
    };
  }, []);

  return (
    <BrowserRouter>
      <Suspense fallback={<div>Loading...</div>}>
        <AppRouter />
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
